enum BlueprintEmailConfigurationType {
    COORDINATOR_BOOKING_CREATED = 'COORDINATOR_BOOKING_CREATED',
}

interface IBlueprintEmailConfiguration {
    type: BlueprintEmailConfigurationType | string;
    subject: string;
    body: string;
    name?: string;
}

interface IBlueprintEmailConfigurationForm {
    configurations: IBlueprintEmailConfiguration[];
}

interface IBlueprintEmailRequestParams {
    accountId: number;
    blueprintId: string;
}

abstract class IBlueprintEmailConfigurationDAO {
    public abstract getEmailConfigurations(
        params: IBlueprintEmailRequestParams
    ): Promise<IBlueprintEmailConfigurationForm>;

    public abstract getDefaultEmailConfigurations(
        params: IBlueprintEmailRequestParams
    ): Promise<IBlueprintEmailConfigurationForm>;

    public abstract updateEmailConfigurations(
        params: IBlueprintEmailRequestParams & IBlueprintEmailConfigurationForm
    ): Promise<IBlueprintEmailConfigurationForm>;
}

export {
    BlueprintEmailConfigurationType,
    IBlueprintEmailConfiguration,
    IBlueprintEmailConfigurationForm,
    IBlueprintEmailRequestParams,
    IBlueprintEmailConfigurationDAO,
};
